import {AppUrls} from 'shared/config/model/urls';

import React from 'react';
import {UseFormRegister} from 'react-hook-form';
import {t} from '@lingui/core/macro';

import Checkbox from 'shared/ui/Checkbox/Checkbox';
import HintQuestion from 'shared/ui/Hint/HintQuestion';

import styles from './HideBannerCheckbox.module.scss';

interface IHideBannerCheckboxProps {
    register: UseFormRegister<any>;
    name: string;
    enabled: boolean;
}

const HideBannerCheckbox: React.FC<IHideBannerCheckboxProps> = ({register, name, enabled}) => {
    return (
        <div className={styles.checkboxWrapper}>
            <Checkbox id={name} {...register(name)} disabled={!enabled}>
                <span className={styles.labelWrapper}>
                    {t`Отключить фирменные баннера`} {t`Overseer`}

                    {!enabled && (
                        <HintQuestion placement="top">
                            <>
                                {t`Доступно на тарифе `}
                                <a href={AppUrls.TARIFFS}>{t`Компания`}</a>
                            </>
                        </HintQuestion>
                    )}
                </span>
            </Checkbox>
        </div>
    );
};

export default HideBannerCheckbox;
